// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"bc2582f4","168":"7f820904","453":"29d12807","534":"5442d9db","905":"6591a8eb","988":"fe043855"}[chunkId] + ".chunk.js";
};